<mode-format-dropdown-list
  [menuItems]="menuItems"
  [label]="'Rotate labels'"
  [menuItems]="menuItems"
  [selected]="selectedItem"
  (selectedChange)="selectItem($event)"
></mode-format-dropdown-list>
